// SPEC-142 §3(9): one place that turns a Blob into a browser download — the
// anchor-click + object-URL create/revoke lifecycle. Was hand-rolled identically
// in the server-CSV export (api.ts), the data-table export, and the Reports page
// CSV/PNG exporters. Import this instead of re-writing the five-line dance.
// SPEC-518: the saved name is always brand-named (brandedFilename, lib/environment.ts).
import { brandedFilename } from './environment';

export { brandedFilename };

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = brandedFilename(filename);
  a.click();
  URL.revokeObjectURL(url);
}
